// Prefill du formulaire (bloc 8) depuis les cartes tamis (bloc 5, voir
// sections/rmt-tamis.liquid data-rmt-select) — PAS un configurateur, juste
// 2 champs preremplis (besoin + tamis souhaite) puis scroll jusqu'au
// formulaire. Ecoute au niveau document : fonctionne quel que soit l'ordre
// de chargement des 2 sections.
//
// 2026-09-03 : trackEvent() relaie aussi vers window.HexagonAnalytics
// (Shopify.analytics.publish) — audit/mise en place analytics, brief dedie.
(function () {
  var TAMIS_LABELS = { controle: 'Contrôle', equilibre: 'Équilibre', puissance: 'Puissance' };

  function trackEvent(name, detail) {
    var fullName = 'hexagon:rmt-' + name;
    document.dispatchEvent(new CustomEvent(fullName, { detail: detail || {} }));
    if (window.HexagonAnalytics) window.HexagonAnalytics.publish(fullName, detail);
  }

  // Brief V2 : le champ "Tamis souhaité" ne s'affiche que lorsque le client
  // choisit "Choisir un autre profil" — inutile pour "Reprendre le même
  // tamis" ou "Être conseillé".
  function syncTamisField() {
    var besoinEl = document.querySelector('[data-rmt-form-besoin]');
    var tamisField = document.querySelector('[data-rmt-form-tamis-field]');
    if (!besoinEl || !tamisField) return;
    tamisField.hidden = besoinEl.value !== 'Choisir un autre profil';
  }

  document.addEventListener('DOMContentLoaded', syncTamisField);
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-rmt-form-besoin]')) syncTamisField();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rmt-select]');
    if (!btn) return;

    var id = btn.getAttribute('data-rmt-select');
    var besoinEl = document.querySelector('[data-rmt-form-besoin]');
    var tamisEl = document.querySelector('[data-rmt-form-tamis]');
    var form = document.getElementById('RmtForm');

    if (id === 'conseil') {
      if (besoinEl) besoinEl.value = 'Être conseillé';
      if (tamisEl) tamisEl.value = '';
    } else if (id === 'conserver') {
      if (besoinEl) besoinEl.value = 'Reprendre le même tamis';
      if (tamisEl) tamisEl.value = '';
    } else {
      var label = TAMIS_LABELS[id];
      if (besoinEl) besoinEl.value = 'Choisir un autre profil';
      if (tamisEl && label) tamisEl.value = label;
    }

    trackEvent('tamis-select', { tamis: id });
    syncTamisField();

    if (form) {
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
